import React__default from 'react';
import { Row } from 'reactstrap';
import ElementRenderer from './ElementRenderer.js';

const RowCreator = (props) => {
    const { elements, keySuffix, externalData, children, CustomFormComponents } = props;
    return (React__default.createElement(Row, { className: "row-creator" }, elements.length > 0 &&
        elements.map(element => (React__default.createElement(ElementRenderer, { key: element.key, element: element, CustomFormComponents: CustomFormComponents, keySuffix: keySuffix, externalData: externalData, 
            // eslint-disable-next-line react/no-children-prop
            children: children })))));
};

export { RowCreator as default };
//# sourceMappingURL=RowCreator.js.map
